import api from 'api'
import { REJECT_LEADS } from '../constants/endpointKeys'
import { type IRejectLeadsPayload, type IRejectLeadsResponse } from './types'

export async function rejectLeads(payload: IRejectLeadsPayload) {
  return await api.put<IRejectLeadsResponse>(REJECT_LEADS, payload)
}
